class GalleryDrag {
  constructor() {
    // Initialize both main gallery and thumbnails
    this.mainGallery = document.querySelector('#Slider-Gallery-template--18928067707138__main');
    this.thumbnailList = document.querySelector('.thumbnail-list');
    
    if (this.mainGallery) {
      this.initializeGallery(this.mainGallery);
    }
    
    if (this.thumbnailList) {
      this.initializeGallery(this.thumbnailList);
    }
  }

  initializeGallery(element) {
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    
    // Set initial styles
    element.style.cursor = 'grab';
    element.style.userSelect = 'none';
    
    const handleMouseDown = (e) => {
      isDragging = true;
      element.style.cursor = 'grabbing';
      startX = e.pageX - element.offsetLeft;
      scrollLeft = element.scrollLeft;
      
      // Add grabbing class to all children
      element.querySelectorAll('*').forEach(el => {
        el.style.cursor = 'grabbing';
      });
    };

    const handleMouseMove = (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - element.offsetLeft;
      const distance = (x - startX) * 1.5; // Adjust sensitivity
      element.scrollLeft = scrollLeft - distance;
    };

    const handleMouseUp = () => {
      isDragging = false;
      element.style.cursor = 'grab';
      
      // Reset cursor for all children
      element.querySelectorAll('*').forEach(el => {
        el.style.cursor = '';
      });
    };

    // Remove any existing listeners
    element.removeEventListener('mousedown', handleMouseDown);
    element.removeEventListener('mousemove', handleMouseMove);
    element.removeEventListener('mouseup', handleMouseUp);
    element.removeEventListener('mouseleave', handleMouseUp);

    // Add event listeners
    element.addEventListener('mousedown', handleMouseDown);
    element.addEventListener('mousemove', handleMouseMove);
    element.addEventListener('mouseup', handleMouseUp);
    element.addEventListener('mouseleave', handleMouseUp);

    // Prevent default drag behavior on images
    element.querySelectorAll('img').forEach(img => {
      img.draggable = false;
      img.addEventListener('dragstart', (e) => e.preventDefault());
    });
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  new GalleryDrag();
});

// Handle Shopify section reloads
document.addEventListener('shopify:section:load', () => {
  new GalleryDrag();
});

// Watch for dynamic content changes
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      new GalleryDrag();
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});